import React, { useMemo } from 'react';
import Button from '@material-ui/core/Button';
import { CircularProgress } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { getDetailRowLayout, renderDetailRow, PanelLoadError } from '../TracePanelShared';
import ContextVariablesPanel from './ContextVariablesPanel';
import '../TracePanelStyles.css';

const ConversationItemContext = ({
    detailLayout = 'llm',
    contextItems,
    contextLoading,
    contextLoadError,
    onRetryContext,
    openContext,
    onOpenContextChange,
}) => {
    const { t } = useTranslation();
    const rowLayout = getDetailRowLayout(detailLayout);

    const visibleContextItems = useMemo(() => {
        if (!openContext) {
            return [];
        }

        return [...contextItems].sort((left, right) =>
            left.name.localeCompare(right.name, undefined, { sensitivity: 'base' })
        );
    }, [contextItems, openContext]);

    const renderContextActionRow = (content) => renderDetailRow({
        content,
        alignItems: 'flex-start',
        marginTop: 4,
        ...rowLayout,
    });

    return (
        <React.Fragment>
            {openContext ? (
                renderContextActionRow(
                    <>
                        <Button
                            size="small"
                            startIcon={<Remove />}
                            onClick={() => onOpenContextChange(false)}
                        >
                            {t('Close context')}
                        </Button>
                        {contextLoading && (
                            <div>
                                <CircularProgress size={20} />
                            </div>
                        )}
                        {!contextLoading && contextLoadError && onRetryContext && (
                            <PanelLoadError
                                message={t('panel_load_failed')}
                                onRetry={onRetryContext}
                                retryLabel={t('Try again')}
                            />
                        )}
                        {!contextLoading && !contextLoadError && contextItems.length === 0 && (
                            <div>
                                <span>{t('No context')}</span>
                            </div>
                        )}
                    </>
                )
            ) : (
                renderContextActionRow(
                    <Button
                        size="small"
                        startIcon={<Add />}
                        onClick={() => onOpenContextChange(true)}
                    >
                        {t('Display context')}
                    </Button>
                )
            )}

            {!contextLoadError && visibleContextItems.length > 0 && (
                <ContextVariablesPanel items={visibleContextItems} />
            )}
        </React.Fragment>
    );
};

export default ConversationItemContext;
